"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelLoginRequest = void 0;
var TelLoginRequest = /** @class */ (function () {
    function TelLoginRequest() {
        this.dynamicCode = '9c92faec499e1183ce05fce753ff894d';
        this.userCode = '18516500680';
        this.registrationID = '';
        this.uniqueId = '';
    }
    return TelLoginRequest;
}());
exports.TelLoginRequest = TelLoginRequest;
;
//# sourceMappingURL=telLogin.request.js.map